export default __webpack_public_path__ + "static/media/team6.6121e981.jpg";